// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-ajax-load {
  text-align: center;
  padding: 40px;
  position: relative;
}

.ant-ajax-load.progressIndicatorPosition-center {
  align-items: center;
}

.ant-ajax-load .sk-spinner-wave.sk-spinner {
  font-size: 10px;
  height: 60px;
  margin: 0 auto;
  text-align: center;
  width: 60px;
}

.ant-ajax-load .sk-spinner-wave div {
  -webkit-animation: sk-stretchdelay 1.2s infinite ease-in-out;
  animation: sk-stretchdelay 1.2s infinite ease-in-out;
  background-color: #a3a3a3;
  display: inline-block;
  height: 100%;
  margin: 0 1px;
  width: 6px;
}

.ant-ajax-load .ant-ajax-text.grey {
  color: #333333;
}
.ant-ajax-load .sk-spinner-wave div.grey {
  background-color: #a3a3a3;
}

.ant-ajax-load .ant-ajax-text.blue {
  color: #1890ff;
}
.ant-ajax-load .sk-spinner-wave div.blue {
  background-color: #1890ff;
}

.ant-ajax-load .ant-ajax-text.white {
  color: #ffffff;
}
.ant-ajax-load .sk-spinner-wave div.white {
  background-color: #ffffff;
}

.ant-ajax-load .sk-spinner-wave .sk-rect2 {
  -webkit-animation-delay: -1.1s;
  animation-delay: -1.1s;
}

.ant-ajax-load .sk-spinner-wave .sk-rect3 {
  -webkit-animation-delay: -1s;
  animation-delay: -1s;
}

.ant-ajax-load .sk-spinner-wave .sk-rect4 {
  -webkit-animation-delay: -0.9s;
  animation-delay: -0.9s;
}

.ant-ajax-load .sk-spinner-wave .sk-rect5 {
  -webkit-animation-delay: -0.8s;
  animation-delay: -0.8s;
}

@-webkit-keyframes sk-stretchdelay {
  0%,
  40%,
  100% {
    -webkit-transform: scaleY(0.4);
  }
  20% {
    -webkit-transform: scaleY(1);
  }
}

@keyframes sk-stretchdelay {
  0%,
  40%,
  100% {
    transform: scaleY(0.4);
    -webkit-transform: scaleY(0.4);
  }
  20% {
    transform: scaleY(1);
    -webkit-transform: scaleY(1);
  }
}
`, "",{"version":3,"sources":["webpack://./client/components/progressIndicator/progressIndicator.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,4DAA4D;EAC5D,oDAAoD;EACpD,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE;;;IAGE,8BAA8B;EAChC;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;;;IAGE,sBAAsB;IACtB,8BAA8B;EAChC;EACA;IACE,oBAAoB;IACpB,4BAA4B;EAC9B;AACF","sourcesContent":[".ant-ajax-load {\n  text-align: center;\n  padding: 40px;\n  position: relative;\n}\n\n.ant-ajax-load.progressIndicatorPosition-center {\n  align-items: center;\n}\n\n.ant-ajax-load .sk-spinner-wave.sk-spinner {\n  font-size: 10px;\n  height: 60px;\n  margin: 0 auto;\n  text-align: center;\n  width: 60px;\n}\n\n.ant-ajax-load .sk-spinner-wave div {\n  -webkit-animation: sk-stretchdelay 1.2s infinite ease-in-out;\n  animation: sk-stretchdelay 1.2s infinite ease-in-out;\n  background-color: #a3a3a3;\n  display: inline-block;\n  height: 100%;\n  margin: 0 1px;\n  width: 6px;\n}\n\n.ant-ajax-load .ant-ajax-text.grey {\n  color: #333333;\n}\n.ant-ajax-load .sk-spinner-wave div.grey {\n  background-color: #a3a3a3;\n}\n\n.ant-ajax-load .ant-ajax-text.blue {\n  color: #1890ff;\n}\n.ant-ajax-load .sk-spinner-wave div.blue {\n  background-color: #1890ff;\n}\n\n.ant-ajax-load .ant-ajax-text.white {\n  color: #ffffff;\n}\n.ant-ajax-load .sk-spinner-wave div.white {\n  background-color: #ffffff;\n}\n\n.ant-ajax-load .sk-spinner-wave .sk-rect2 {\n  -webkit-animation-delay: -1.1s;\n  animation-delay: -1.1s;\n}\n\n.ant-ajax-load .sk-spinner-wave .sk-rect3 {\n  -webkit-animation-delay: -1s;\n  animation-delay: -1s;\n}\n\n.ant-ajax-load .sk-spinner-wave .sk-rect4 {\n  -webkit-animation-delay: -0.9s;\n  animation-delay: -0.9s;\n}\n\n.ant-ajax-load .sk-spinner-wave .sk-rect5 {\n  -webkit-animation-delay: -0.8s;\n  animation-delay: -0.8s;\n}\n\n@-webkit-keyframes sk-stretchdelay {\n  0%,\n  40%,\n  100% {\n    -webkit-transform: scaleY(0.4);\n  }\n  20% {\n    -webkit-transform: scaleY(1);\n  }\n}\n\n@keyframes sk-stretchdelay {\n  0%,\n  40%,\n  100% {\n    transform: scaleY(0.4);\n    -webkit-transform: scaleY(0.4);\n  }\n  20% {\n    transform: scaleY(1);\n    -webkit-transform: scaleY(1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
